import { Component, Inject, OnInit, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LuModalConfig } from 'lu-modal';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { TooltipModalCnf } from './lu-tooltip-modal.models';

@Component({
	// eslint-disable-next-line @angular-eslint/component-selector
	selector: 'lu-tooltip-modal',
	templateUrl: './lu-tooltip-modal.component.html',
	styleUrls: ['./lu-tooltip-modal.component.scss']
})
export class LuTooltipModalComponent implements OnInit {
	options: TooltipModalCnf;
	modalOptions: LuModalConfig;
	private readonly translateService = inject(TranslateService);
	defaultTooltipModalConfig: TooltipModalCnf = {
		message: '',
		confirmLabel: this.translateService.instant('ok'),
		title: this.translateService.instant('lup.info')
	};

	constructor(@Inject(BsModalRef) private modalRef: BsModalRef) {}

	ngOnInit(): void {
		this.options = {
			...this.defaultTooltipModalConfig,
			...this.options
		};

		const { title, confirmLabel } = this.options;

		this.modalOptions = {
			title,
			close: () => {
				this.close();
			},
			primaryActions: [
				{
					onClick: () => {
						this.close();
					},
					class: 'btn--default',
					label: confirmLabel
				}
			]
		};
	}

	close(): void {
		if (this.options && this.options.onClose) {
			this.options.onClose();
		} else {
			this.modalRef.hide();
		}
	}
}
